/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import SmoothScrollbar from 'smooth-scrollbar';

const Scrollbar = (props) => {
  const container = useRef();
  let scrollbar = null;

  useEffect(() => {
    scrollbar = SmoothScrollbar.init(container.current, props);

    if (typeof window !== 'undefined') window.scrollb = scrollbar;

    scrollbar.addListener((status) => {
      if (props.onScroll) props.onScroll(status, scrollbar);
    });

    return () => {
      if (scrollbar) scrollbar.destroy();
    };
  }, []);

  useEffect(() => {
    if (scrollbar) scrollbar.update();
  });

  useEffect(() => {
    if (!scrollbar) return;

    Object.keys(props).forEach((key) => {
      // eslint-disable-next-line no-unsafe-negation
      if (!key in scrollbar.options) return;

      if (key === 'plugins') {
        Object.keys(props.plugins).forEach((pluginName) => {
          scrollbar.updatePluginOptions(pluginName, props.plugins[pluginName]);
        });
      } else {
        scrollbar.options[key] = props[key];
      }
    });
  }, [props]);

  return (
    <section data-scrollbar ref={container} {...props}>
      <div>{props.children}</div>
    </section>
  );
};

Scrollbar.propTypes = {
  damping: PropTypes.number,
  thumbMinSize: PropTypes.number,
  syncCallbacks: PropTypes.bool,
  renderByPixels: PropTypes.bool,
  alwaysShowTracks: PropTypes.bool,
  continuousScrolling: PropTypes.bool,
  delegateTo: PropTypes.element,
  plugins: PropTypes.object,
  onScroll: PropTypes.func,
  children: PropTypes.node,
};

export default Scrollbar;
